import http from '@/utils/http';
const call=async(action,data)=>{const res=await http({url:'/api/admin/v1/contractProjectOrderEvent/'+action,method:'post',data});if(res?.code!==0)throw Error(res?.msg||'业务通知读取失败');return res.data;};export default {list:data=>call('list',data),ack:data=>call('ack',data)};
